import { TradingSystem } from '@monorepo/types';

export enum TradingPlatforms {
  Web = 'web',
  Mac = 'mac-app',
  Windows = 'windows-app',
  Linux = 'linux-app',
  Android = 'android-app',
  iOS = 'ios-app',
}

export enum TsValueType {
  Percentage = 'percentage',
  Amount = 'amount',
}

export const getTradingSystemName = (
  ts: TradingSystem,
  type: 'hub' | 'admin' = 'hub',
) => TradingSystemNames?.[ts]?.[type];

const TradingSystemNames: Record<
  TradingSystem,
  {
    admin: string;
    hub: string;
  }
> = {
  [TradingSystem.MatchTrader]: {
    admin: 'MatchTrader',
    hub: 'MatchTrader',
  },
  [TradingSystem.TraderEvolution]: {
    admin: 'Trader Evolution',
    hub: 'Trader Evolution',
  },
  [TradingSystem.MetaTraderFive]: {
    admin: 'MetaTrader',
    hub: 'MetaTrader5',
  },
  [TradingSystem.MetaTraderXP]: {
    admin: 'MetaTrader XP',
    hub: 'MetaTrader5',
  },
  [TradingSystem.MetaTraderContest]: {
    admin: 'MetaTrader Contest',
    hub: 'MetaTrader5',
  },
  [TradingSystem.CTrader]: {
    admin: 'cTrader',
    hub: 'cTrader',
  },
  [TradingSystem.BlackArrowFutures]: {
    admin: 'Black Arrow Futures',
    hub: 'Black Arrow',
  },
};
